module.exports = __webpack_public_path__ + "static/media/carousel_img7.b88aae35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/carousel_img7.jpg
// module id = 369
// module chunks = 0